var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#cart_icon_svg__filter0_d_1_8444)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 46,
    r: 36,
    fill: "#282828"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cart_icon_svg__clip0_1_8444)",
    stroke: "#E4E4E4",
    strokeWidth: 3.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.39 61.653a1.565 1.565 0 100-3.13 1.565 1.565 0 000 3.13zM44.173 61.653a1.565 1.565 0 100-3.13 1.565 1.565 0 000 3.13zM31.651 28.784h6.261l4.195 20.958a3.13 3.13 0 003.13 2.52h15.215a3.13 3.13 0 003.13-2.52l2.504-13.132H39.478"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cart_icon_svg__clip0_1_8444"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(30.086 27.218)",
    d: "M0 0h37.565v37.565H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cart_icon_svg__filter0_d_1_8444",
    x: 0.348,
    y: 0.609,
    width: 103.304,
    height: 103.304,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.261
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.826
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_8444"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_8444",
    result: "shape"
  })))));
}
export default __webpack_public_path__ + "static/media/cart_icon.3d0951e8.svg";
export { SvgCartIcon as ReactComponent };